<template>
  <cec-select-search
    v-model="internalValue"
    :options="options"
    :state="estadoComponente"
    :disabled="desabilitarInput || loading"
    :placeholder="placeholder"
    :input-class="inputClass"
  />
</template>

<script>
import axios from 'axios'
import CecSelectSearch from '@/views/componentes/dropdown/CecSelectSearch.vue'

export default {
  name: 'ProducaoFormulaProcessoFormulaDropDown',
  components: { CecSelectSearch },
  props: {
    value: {
      type: [String, Number, null],
      default: null
    },
    idInicial: {
      type: [String, Number, null],
      default: null
    },
    classeRequired: Boolean,
    desabilitarInput: Boolean,
    state: {
      type: [Boolean, null],
      default: null
    },
    inputClass: {
      type: [String, Object, Array],
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Pesquise a fórmula ativa...'
    }
  },
  data() {
    return {
      internalValue: this.value != null ? this.value : this.idInicial,
      options: [],
      loading: false
    }
  },
  computed: {
    estadoComponente() {
      if (this.state !== null) return this.state
      if (this.classeRequired && !this.internalValue) return false
      return null
    }
  },
  watch: {
    value(newVal) {
      this.internalValue = newVal
    },
    idInicial(newVal) {
      if (this.value == null) {
        this.internalValue = newVal
      }
    },
    internalValue(newVal) {
      const selecionado = this.options.find(option => option.value === newVal)
      this.$emit('input', newVal)
      this.$emit('change', newVal)
      this.$emit('retornaRegistro', selecionado ? selecionado.raw : null)
    }
  },
  created() {
    this.fetchRegistros()
  },
  methods: {
    async fetchRegistros() {
      this.loading = true
      try {
        const { data } = await axios.get('/api/protected/producao-formula/pesquisar', {
          params: { situacao: '1' }
        })
        this.options = (data || []).map(item => ({
          value: item.ID,
          text: `${item.ID} - ${item.DESCRICAO} | ${item.PRODUTO_CODIGONOME}`,
          raw: item
        }))
      } catch (error) {
        this.options = []
        console.error('Erro ao buscar fórmulas ativas', error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/producao/producao-formula-processo/ProducaoFormulaProcessoFormulaDropDown.vue